/** Vérifie qu'un asset existe (erreur claire si le .mind manque). */
export async function assetExists(url: string): Promise<boolean> {
  try {
    const res = await fetch(url, { method: 'HEAD' });
    return res.ok;
  } catch {
    return false;
  }
}

/**
 * Précharge un son. Ne jette jamais : si le fichier manque,
 * `play()` est simplement un no-op.
 */
export function loadSound(url: string): { play: () => void } {
  const audio = new Audio();
  let ready = false;
  audio.preload = 'auto';
  audio.addEventListener('canplaythrough', () => { ready = true; }, { once: true });
  audio.addEventListener('error', () => {
    console.warn(`[assets] Son introuvable (${url}) — expérience silencieuse.`);
  });
  audio.src = url;
  return {
    play() {
      if (!ready) return;
      audio.currentTime = 0;
      void audio.play().catch(() => { /* autoplay refusé : non bloquant */ });
    },
  };
}
